module.exports = __webpack_public_path__ + "static/DEV5-95a8d5db5301b572742e8f0a8b65543a.jpg";